import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactEcharts from 'echarts-for-react';
import Card from '@material-ui/core/Card';

const StyledTableRow = withStyles((theme) => ({
    
}))(TableRow);
const useStyles = makeStyles((theme) => {});

let times = ['12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'];
const VolumeChart = props => {
    const classes = useStyles();
    const theme = useTheme();
    const [myOptions, setmyOptions] = React.useState({})
    const [getAmTimeData, setAmTimeData] = React.useState([{ "key": "0", "value": "0" }]);
    const [getGraphData, setGraphData] = React.useState([]);
    const [getCountData, setCountData] = React.useState([]);
    const [getTotalCount, setTotalCount] = React.useState(0);
    const [getTotalCountPm, setTotalCountPM] = React.useState([]);
    const [timeArrPm, setTimeArrPm] = React.useState([
        '12.00PM', '1.00PM', '2.00PM', '3.00PM',
        '4.00PM', '5.00PM', '6.00PM', '7.00PM', '8.00PM', '9.00PM', '10.00PM', '11.00PM']);

    const [timeArrAm, setTimeArrAm] = React.useState([
        '12.00AM', '1.00AM', '2.00AM', '3.00AM', '4.00AM', '5.00AM', '6.00AM', '7.00AM',
        '8.00AM', '9.00AM', '10.00AM', '11.00AM']);

    const [defaultTimeArray, setDefaultTimeArray] = React.useState([
        '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'])
    React.useEffect(() => {        
        if (props.data != undefined) {
            let arrayCountAm = [];
            let arrayCountPm = [];
            let graphCountData = [];
            let graphData = [];
            defaultTimeArray.map((v, countIndex) => {
                let element;
                for (let i = 0; i < props.data.count.length; i++) {
                    const hour = props.data.count[i].key.split(" ")[0].split(":")[0];
                    const ampm = props.data.count[i].key.split(" ")[1];              
                    const vhour = v.split(" ")[0].split(":")[0];      
                    if ((vhour === hour) && v.includes(ampm)){
                        element = {data:{count:props.data.count[i].count, key:v}, condition : true};
                        break;
                    }
                    else
                        element = {data:{count:" ", key:v}, condition : false};
                }                
                graphData.push(element);
                if (element.condition)
                    graphCountData.push(element.data.count);
                else
                    graphCountData.push(" ");
            })
            setGraphData(graphCountData);
            myOptionFunction(graphCountData);

            for (let i = 0; i < graphData.length; i++) {
                if (graphData[i].data.key.includes("AM")) {
                    arrayCountAm.push(graphData[i].data);
                } else if (graphData[i].data.key.includes("PM")) {
                    arrayCountPm.push(graphData[i].data);
                }
            }
            
            setTotalCountPM(arrayCountPm);
            setCountData(arrayCountAm);
            setTotalCount(props.data.totalCount);
        } else {
            setCountData([]);
            setTotalCountPM([]);
            setTotalCount(0);
        }

    }, [props.data]) 
    function myOptionFunction(graphCountData) {
        setmyOptions({
            xAxis: {
                data: defaultTimeArray, //props.data && props.data.startTime.length > 0 ? props.data.startTime : defaultTimeArray
                axisLabel: {
                    rotate: 45,                    
                    fontSize: 10,
                },
                splitLine: {
                    show: true,
                    lineStyle: {              
                      color: '#F4F4F5',              
                      width: 1
                    }
                },               
                axisLine : {
                    show : false
                },
                axisTick : {
                    show : false
                },
                type: 'category',
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    show: false,
                    type: 'none'
                },
                textStyle: {
                    fontSize: 10,
                }
            },
            grid: {
                height: 'auto',
                top: '20px',
                left: '40px',
                right: '15px',
                bottom:'50px',
            },
            yAxis: {
                splitLine: {
                    show: true,
                    lineStyle: {              
                      color: '#F4F4F5',              
                      width: 1
                    }
                },                
                axisLine : {
                    show : false
                },
                axisTick : {
                    show : false
                },
                axisLabel: {                    
                    // fontSize: sessionStorage.getItem('midTabWidth') >= 1200 && sessionStorage.getItem('midTabWidth') <= 3500 ? 10 : sessionStorage.getItem('midTabWidth') >= 3501 ? 24 : 12,
                    fontSize: 10
                },
            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        color: "#3B82F6",
                    },
                    barWidth: '29px',
                    data: graphCountData,
                }
            ]
        })
    }
    //This method is use for create echart .... start

    return (
        <React.Fragment>
            <div className={classes.countsTabMain}>
                <div className='chart-details-volume'>
                    <Card>
                        {myOptions && <ReactEcharts option={myOptions} style={{ marginLeft: '0px',height:'100%'}} />}
                    </Card>    
                </div>
                <div className={classes.combinedTableBlock}>
                    <div className='tb-volume-info-counts-main'>
                        <div className='blockDiv'>
                            <TableContainer component={Paper}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right" className={classes.tableHead} style={{borderBottom:'1px solid #d4d4d8'}}>Start Time</TableCell>
                                            <TableCell align="right" className={classes.tableHead} style={{borderBottom:'1px solid #d4d4d8'}}>Count</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {
                                            getCountData.map((value, index) => {
                                                return (
                                                    <StyledTableRow key={index}>
                                                        <TableCell align="right" className={classes.dataTD}>{value.key}</TableCell>
                                                        <TableCell align="right" className={classes.dataTD}>{typeof(value.count) === "number" ? value.count : '--' }</TableCell>
                                                    </StyledTableRow>
                                                )
                                            })
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className='blockDiv'>
                            <TableContainer component={Paper}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right" className={classes.tableHead} style={{borderBottom:'1px solid #d4d4d8'}}>Start Time</TableCell>
                                            <TableCell align="right" className={classes.tableHead} style={{borderBottom:'1px solid #d4d4d8'}}>Count</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {
                                            getTotalCountPm.map((eleValue, index) => {
                                                return (
                                                    <StyledTableRow key={index}>
                                                        <TableCell align="right" className={classes.dataTD}>{eleValue.key}</TableCell>
                                                        <TableCell align="right" className={classes.dataTD}>{typeof(eleValue.count) === "number" ? eleValue.count : '--'}</TableCell>
                                                    </StyledTableRow>
                                                )
                                            })
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className='blockDiv'>
                            <TableContainer component={Paper}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right" className={classes.tableHead}>Total</TableCell>
                                            <TableCell align="right" className={classes.tableHeadSimple}>{typeof(getTotalCount) === "number" ? getTotalCount : '--'}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default VolumeChart;

